import { render, staticRenderFns } from "./ListGroupHorizontal.vue?vue&type=template&id=33ccc1f1&"
import script from "./ListGroupHorizontal.vue?vue&type=script&lang=js&"
export * from "./ListGroupHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports